export const Props = () => ({
  //--------------------------------------------------------------------------
  //                                 Сигнал
  //--------------------------------------------------------------------------
  signal: {
    type: Object,
    required: true,
  }
  //xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
});